import Vue from 'vue'
import Vuetify from 'vuetify'
// import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
import colors from 'vuetify/es5/util/colors'
// import colors from 'vuetify/lib/util/colors'
import es from 'vuetify/es5/locale/es'
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify)

// Helper function to get color from environment variable or colors object
const getColor = (colorString) => {
    if (!colorString) return colors.blue.darken4
    
    // If it's a hex color, return it directly
    if (colorString.startsWith('#')) {
        return colorString
    }
    
    // If it's a color path like 'blue.darken4', resolve it from colors object
    const parts = colorString.split('.')
    let color = colors
    for (const part of parts) {
        color = color[part]
        if (!color) return colors.blue.darken4
    }
    return color
}

const primaryColor = getColor(process.env.MIX_PRIMARY_COLOR)

const opts = {
    iconfont: 'md',
    theme: {
        themes: {
            light: {
                toolbar: primaryColor,
                toolbarList: colors.cyan.darken2,
                listSelected: colors.black,
                primary: primaryColor,
                secondary: colors.amber.base,
                accent: colors.indigo.base,
                background: colors.blueGrey.darken3,
                sidebar: colors.blueGrey.darken4,
                list: colors.teal.darken1,
                show: colors.blue.lighten2,
                create: colors.green.darken1,
                edit: colors.orange.darken3,
                delete: colors.red.darken4,
                searcher: colors.cyan.darken1,
                subtotal: colors.yellow.lighten1,
            },
            dark: {
                toolbar: primaryColor,
                toolbarList: colors.cyan.darken2,
                listSelected: colors.black,
                primary: primaryColor,
                secondary: colors.amber.base,
                accent: colors.indigo.base,
                background: colors.blueGrey.darken4,
                sidebar: colors.blueGrey.darken4,
                list: colors.teal.darken1,
                show: colors.blue.lighten2,
                create: colors.green.darken1,
                edit: colors.orange.darken3,
                delete: colors.red.darken4,
                searcher: colors.cyan.darken1,
                subtotal: colors.yellow.lighten1,
            },
        },
    },
    lang: {
        locales: { es },
        current: 'es',
    },
    dataIterator: {
        loadingText: 'Cargando datos...',
        // noDataText: 'No hay datos disponibles', // Mensaje para "No hay datos"
        // noResultsText: 'No se encontraron resultados', // Mensaje para "No hay resultados"
    },
}
export default new Vuetify(opts)